import { render, staticRenderFns } from "./home-component.vue?vue&type=template&id=71efbe33&scoped=true&"
import script from "./home-component.vue?vue&type=script&lang=js&"
export * from "./home-component.vue?vue&type=script&lang=js&"
import style0 from "./home-component.vue?vue&type=style&index=0&id=71efbe33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71efbe33",
  null
  
)

export default component.exports